"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractErrorMessage = void 0;
const lodash_1 = __importDefault(require("lodash"));
const extractErrorMessage = (e) => {
    if (e.data?.message) {
        return e.data.message;
    }
    else if (e.response?.data?.message) {
        return e.response.data.message;
    }
    else if (e.data?.error) {
        if (!lodash_1.default.isArray(e.data.error)) {
            return e.data.error;
        }
        if (e.data.error[0]?.message) {
            return e.data.error[0].message;
        }
        else {
            return e.data.error[0];
        }
    }
    else if (e.message) {
        return e.message;
    }
    else {
        return e.toString();
    }
};
exports.extractErrorMessage = extractErrorMessage;
//# sourceMappingURL=extract-error-message.js.map